import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Table } from 'antd'

import { PortalLayout } from '../../components'
import LayoutImageBg from '../../../../assets/images/farmer-portal-reports.png'
import ReportIcon from '../../../../assets/images/productivity-report.png'
import PinMapIcon from '../../../../assets/images/pin-map.png'
import MapIcon from '../../../../assets/images/icone_map.png'
import { getMessage } from '../../../../util/IntlMessages'
import { api, request } from '../../../../util/handlerRequestUtil'

import './Styles.css'

const ProductivityRankByRegion = ({ history }) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [cityInfo, setCityInfo] = useState('')
  const [macroRegion, setMacroRegion] = useState('')
  const [report, setReport] = useState([])
  const [qttLocations, setQttLocations] = useState('0')

  useLayoutEffect(() => {
    if (!currentUser) {
      return history.push('/farmers/portal')
    }
  }, [])

  useEffect(() => {
    const city = JSON.parse(sessionStorage.getItem('selected_city')) || {}

    const { macroRegion, microRegion, description, stateAbbreviation } = city

    setCityInfo(`${description} - ${stateAbbreviation}`)
    setMacroRegion(macroRegion)

    fetchReport({ macroRegion, microRegion })
  }, [])

  useEffect(() => {
    countLocations()
  }, [])

  async function countLocations() {
    const { count = 0 } = await request(api.countLocations())
    setQttLocations(new Intl.NumberFormat('pt-BR').format(count))
  }

  async function fetchReport(filters) {
    const { productivityByRegion } = await request(api.dashboardFarmerPortal(filters))

    if (productivityByRegion.length === 0) return

    const sorted = productivityByRegion.sort((a, b) => b.productivity - a.productivity)

    const values = sorted.map((item, i) => ({
      rank: i + 1,
      cultivar: item.material,
      productivity: item.productivity.toFixed(2),
      area: item.qtdAreas
    }))

    setReport(values.slice(0, 10))
  }

  const getColumns = () => [
    {
      title: getMessage('farmer.portal.ranking'),
      width: '90px',
      render: (item) => <p className="table-cell-text">{item.rank}</p>
    },
    {
      title: getMessage('farmer.portal.cultivar'),
      width: '159px',
      render: (item) => <p className="table-cell-text">{item.cultivar}</p>
    },
    {
      title: getMessage('productivity'),
      width: '159px',
      render: (item) => <p className="table-cell-text">{item.productivity} sc/ha</p>
    },
    {
      title: getMessage('farmer.portal.qtt.camps'),
      width: '159px',
      render: (item) => <p className="table-cell-text">{item.area} campos</p>
    }
  ]

  return (
    <PortalLayout
      bgImage={LayoutImageBg}
      centerImage={ReportIcon}
      title="Resultados do relatório"
      subtitle={getMessage('farmer.portal.productivity.rank')}
      showAction
    >
      <div className="productivity-rank-by-region">
        <div className="wrapper">
          <p className="title">{getMessage('farmer.portal.productivity.rank')}</p>
          <p className="subtitle">
            Os dados informados são relacionados a safra 2021/2022 e de um total de {qttLocations} agricultores
          </p>

          <div className="box">
            <img className="pin-map-icon" src={PinMapIcon} alt="pin-map" />
            <p className="bodyText">Município de {cityInfo}</p>
          </div>

          <div className="box">
            <img className="pin-map-icon" src={MapIcon} alt="map-icon" />
            <p className="bodyText">Macro Região - {macroRegion}</p>
          </div>

          <div className="table-wrapper">
            <p className="table-title">Materiais plantados por região</p>
            <Table
              key="productivity-rank"
              columns={getColumns()}
              rowKey={(record) => `${record.cultivar}_${record.rank}`}
              pagination={false}
              scroll={{ x: true }}
              dataSource={report}
            />
          </div>
        </div>
      </div>
    </PortalLayout>
  )
}

export default ProductivityRankByRegion
